<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25 5H7a2 2 0 00-2 2v11a2 2 0 002 2h18a2 2 0 002-2V7a2 2 0 00-2-2zm0 2v2H7V7zM7 18v-7h18v7z"/><path d="M11 13H9a1 1 0 000 2h2a1 1 0 000-2zM26 23a3 3 0 00-2.82 2h-4.36a3 3 0 00-5.64 0H8.82a3 3 0 100 2h4.36a3 3 0 005.64 0h4.36A3 3 0 1026 23zm-10 4a1 1 0 111-1 1 1 0 01-1 1zm10 0a1 1 0 111-1 1 1 0 01-1 1z"/></svg>